import LoanDocumentsWorkflows from "../../../../src/pages/use-cases/page-content/agreements-and-contracts/loan-documents-workflows.md";
import * as React from 'react';
export default {
  LoanDocumentsWorkflows,
  React
};